import { useAuth } from "../context/AuthContext";
import ChatbotWidget from "./ChatbotWidget";

export default function AuthenticatedChatbot() {
    const { user, hasPermission } = useAuth();
    if (!user) return null;
    // El backend exige ai_chat.use en todos los endpoints del chat; sin el
    // permiso, mostrar el widget sería ofrecer un botón que responde 403.
    if (!hasPermission("ai_chat", "use")) return null;
    return <ChatbotWidget />;
}
